import useActionReducer from '@admin/hooks/use_action_reducer'
import SharesField from './sharesfield'
import * as actions from './actions'
import PropTypes from 'prop-types'
import reducer from './reducer'
import React from 'react'

const SharesFieldContainer = (props) => {

  const [state, handlers] = useActionReducer({
    display_name: 'Sharesfield',
    actions,
    props,
    reducer
  })

  const mergedProps = {
    ...props,
    ...state,
    ...handlers
  }

  return <SharesField { ...mergedProps } />

}

SharesFieldContainer.propTypes = {}

export default SharesFieldContainer